import { render, staticRenderFns } from "./CampaignPages.vue?vue&type=template&id=38ef2031&"
import script from "./CampaignPages.vue?vue&type=script&lang=ts&"
export * from "./CampaignPages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports